export default "__VITE_ASSET__DDOYfeh1__"